import { render, staticRenderFns } from "./WfDevBleConfigForm.vue?vue&type=template&id=0084a1f5&"
import script from "./WfDevBleConfigForm.vue?vue&type=script&lang=js&"
export * from "./WfDevBleConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports